import { textToneClass, type ChipTone } from './tokens'

const clampRatio = (value: number): number => {
  if (!Number.isFinite(value)) return 0
  return Math.min(1, Math.max(0, value))
}

export const ThresholdMeter = ({
  value,
  threshold,
  label,
  valueLabel,
  thresholdLabel,
  metTone = 'success',
  missedTone = 'warning',
}: {
  value: number
  threshold: number
  label: string
  valueLabel: string
  thresholdLabel: string
  metTone?: ChipTone
  missedTone?: ChipTone
}) => {
  const reading = clampRatio(value)
  const gate = clampRatio(threshold)
  const tone = reading >= gate ? metTone : missedTone

  return (
    <div className={`threshold ${textToneClass(tone)}`}>
      <div
        className="threshold-track"
        role="img"
        aria-label={`${label} ${valueLabel}，${thresholdLabel}`}
      >
        <span className="threshold-fill" style={{ inlineSize: `${reading * 100}%` }} />
        <span className="threshold-gate" style={{ insetInlineStart: `${gate * 100}%` }} />
      </div>
      <div className="threshold-legend">
        <span className="threshold-value num">{valueLabel}</span>
        <span className="threshold-gate-label num">{thresholdLabel}</span>
      </div>
    </div>
  )
}
